/**
 * Aviso de que a lista de pacientes do médico mudou — SALVIA-955.
 *
 * Telas que guardam a lista entre aberturas (o Novo atendimento do botão
 * flutuante) escutam e recarregam na próxima vez que abrirem. Quem muda a
 * lista avisa: ocultar/reexibir paciente, cadastrar ou vincular um novo.
 *
 * Mesmo molde do patientDataBus, sem debounce: é um aviso raro.
 */

const listeners = new Set();

/** Registra um callback; retorna uma função para cancelar a inscrição. */
export function onPatientListChanged(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

export function emitPatientListChanged() {
  listeners.forEach((cb) => {
    try {
      cb();
    } catch (e) {
      console.error("[patientListBus] listener falhou:", e);
    }
  });
}
